angular.module('impactx.userlist').directive('ixAfterRender', function ($timeout, dataGen) {
    return {
        restrict: 'A',
        link: function (scope, element, attr) {

                scope.$watchCollection('displayCollection',function(newVale, oldValue)
                {
                    var ids = [];
                    angular.forEach(scope.displayCollection, function(user, index)
                    {
                        if(user && !user.alreadyChecked)
                        {
                            ids.push(user.id);
                        }
                    });
                    var tempScope = {};
                    if (ids.length > 0) {
                        dataGen.getData(tempScope, {ids: ids}, "/user/view/image").then(function(){
                            angular.forEach(scope.displayCollection, function (user, index) {
                                user.alreadyChecked = true;
                                var holder = tempScope.data[user.id];
                                if (holder) {
                                    user.imageUrl = holder.imageUrl;
                                }
                            });
                        }, true);
                    }
                });
            }

    }
});